// import { get } from 'lodash';
// import { images as iK } from 'src/tools/contentModulesFieldName';
import arrayMove from 'array-move';
import { generateTabPoster } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';
import { responsivePosterTypeDict } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
// import { posters, tabs } from 'src/tools/contentModulesFieldName';
// import { set } from 'lodash';
import { generateResponsiveImage } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';

const usePosterTab = ({ form }) => {
  const handleOnTypeChange = (value, onChange, type) => {
    // const prefixName = [tabs, index];
    const correctNum = responsivePosterTypeDict[type];
    // const k = [tabs, index, posters];

    const images = value || [];
    const currentLen = images.length;

    if (currentLen > correctNum) {
      const newImages = images.slice(0, correctNum);
      onChange(newImages);
    } else if (currentLen < correctNum) {
      const diff = correctNum - currentLen;
      const a = [];
      for (let i = 0; i < diff; i++) {
        a.push(generateResponsiveImage(`Poster ${currentLen + i + 1}`));
      }
      onChange([...images, ...a]);

      // form.setFieldsValue({ [k]: diff });
    }
  };
  const handleOnAddTab = (value, onChange, length) => {
    const pc = generateTabPoster(length + 1);
    //const { pc } = ;
    onChange([...(value || []), pc]);
  };
  const handleOnDeleteTab = (value, onChange, index) => {
    const nValue = (value || []).filter((_, i) => {
      return i !== index;
    });
    onChange(nValue);
  };
  const handleOnSortTab = (value, onChange, from, to) => {
    const nValue = arrayMove(value || [], from, to);
    onChange(nValue);
  };
  const handleOnTabPosterSort = (value, onChange, from, to) => {
    const nValue = arrayMove(value || [], from, to);
    onChange(nValue);
  };
  const handleOnModalConfirm = (value, onChange, newPoster, index) => {
    const nV = (value || []).map((d, i) => {
      if (i === index) {
        return newPoster;
      } else {
        return d;
      }
    });
    onChange(nV);
  };

  return {
    handleOnModalConfirm,
    handleOnAddTab,
    handleOnDeleteTab,
    handleOnSortTab,
    handleOnTabPosterSort,
    handleOnTypeChange,
  };
};
export { usePosterTab };
